import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Crown, Lock } from "lucide-react";
import { ADMIN } from "@/constants/testIds";
import { toast } from "sonner";

export default function AdmiralLogin() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (!loading && user && user.role === "admin") return <Navigate to="/admiral" replace />;
  if (!loading && user && user.role === "guardian") return <Navigate to="/guardian" replace />;
  if (!loading && user && user.role === "heir") return <Navigate to="/junior" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const result = await login(email, password);
      toast.success("Sovereign access granted");
      const role = result?.role;
      if (role === "guardian") navigate("/guardian");
      else if (role === "heir") navigate("/junior");
      else navigate("/admiral");
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "Authentication failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Layout>
      <section className="relative min-h-[80vh] flex items-center justify-center px-6 py-16">
        <form onSubmit={submit} className="glass border border-[#C9A227]/40 w-full max-w-md p-8 md:p-10" style={{borderRadius:0}}>
          <div className="flex items-center gap-3 mb-2">
            <Crown className="text-[#C9A227]"/>
            <span className="label-gold">Admiral Dashboard</span>
          </div>
          <h1 className="text-3xl md:text-4xl font-black uppercase tracking-tighter text-white">
            Sovereign <span className="gold-shimmer">Access</span>.
          </h1>
          <p className="text-white/55 text-sm mt-2">
            For the Grand Sovereign only. The Command Roster is restricted.
          </p>

          <div className="space-y-5 mt-7">
            <div>
              <label className="label-gold">Email</label>
              <input type="email" required className="siren-input"
                value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="grandsovereign@…" data-testid={ADMIN.loginEmail}/>
            </div>
            <div>
              <label className="label-gold">Password</label>
              <input type="password" required className="siren-input"
                value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••" data-testid={ADMIN.loginPassword}/>
            </div>
          </div>

          <button disabled={busy} type="submit" className="btn-gold w-full mt-7 text-xs" data-testid={ADMIN.loginBtn}>
            <Lock size={14} className="inline -mt-0.5 mr-2"/>
            {busy ? "Authenticating…" : "Authorize Boarding"}
          </button>
        </form>
      </section>
    </Layout>
  );
}
